import React from 'react';
import {Create, SimpleForm, TextInput} from 'react-admin';

const PackageCalorieCreate = (props) => {
    return (
        <Create {...props}>
            <SimpleForm redirect="show">
                <TextInput source="amount" />
            </SimpleForm>
        </Create>
    );
};

export default PackageCalorieCreate;